import { render } from "./editclassify.vue?vue&type=template&id=456ead0c&scoped=true"
import script from "./editclassify.vue?vue&type=script&lang=js"
export * from "./editclassify.vue?vue&type=script&lang=js"

import "./editclassify.vue?vue&type=style&index=0&id=456ead0c&lang=scss&scoped=true"
import "./editclassify.vue?vue&type=style&index=1&id=456ead0c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mac\\Downloads\\PCguanli\\zhongtaiworkPC\\yungong_1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456ead0c"]])

export default __exports__